import { setLocalStorageLoginToken } from "src/utils/localStorageWorker";
import * as requests from "../../../requests/login/requestCreators";
import { EwaThunk } from "../../types";
import {
  errorLogin,
  noLoginCookieSet,
  requestLogin as requestLoginCreator,
  successLogin,
} from "../actionCreators/authentication/loginCreator";

const requestLogin =
  (
    login: string | undefined,
    password: string | undefined,
    forceCheck?: boolean
  ): EwaThunk =>
  async (dispatch, getState): Promise<void> => {
    const localState = getState().login;

    if (localState.isFetching) {
      return;
    }
    dispatch(requestLoginCreator());
    if (!login && !password) {
      // eslint-disable-next-line

      if (
        (localState.user !== null &&
          localState.user !== undefined &&
          forceCheck !== true) ||
        localState.noCookie === true
      ) {
        return;
      }

      requests
        .loginWithCookie()
        .then(async (response) => {
          const userDto = response.data;

          // todo: Authorization
          if (userDto.token) {
            setLocalStorageLoginToken(userDto.token);
          }

          const { data: isUserAdmin } = await requests.isUserAdmin();
          dispatch(successLogin(userDto, isUserAdmin));
        })
        .catch((error) => {
          dispatch(noLoginCookieSet());
          if (error.response.status !== 401) {
            dispatch(errorLogin(error.response));
          }
        });
    } else {
      requests
        .login({
          login: login as string,
          password: password as string,
        })
        .then(async (response) => {
          const userDto = response.data;

          // todo: Authorization
          setLocalStorageLoginToken(userDto.token);

          const { data: isUserAdmin } = await requests.isUserAdmin();
          dispatch(successLogin(userDto, isUserAdmin));
        })
        .catch((error) => dispatch(errorLogin(error.response.data)));
    }
  };

export default requestLogin;
